import React from 'react';

export const questions = [{
  q: <>Should I first play Unboxing the mind of a Cryptic Killer?</>,
  a: 'No need. Parallel Lab is the second game in the series, but we designed it to be played comfortably as a standalone game.'
}, {
  q: 'How other players join the game?',
  a: 'You just use the same License Key. Pay once for the whole team!'
}, {
  q: 'Can we play on mobile devices, e.g., smartphones?',
  a: 'The game is designed for PCs, laptops, or tablets. The bigger your screen, the better, so we don\'t recommend playing on smartphones, although if you want a challenge, then that\'s on you!'
}, {
  q: 'What to do when we are stuck on one of the puzzles?',
  a: 'Each of the puzzles has detailed hints from the first, which will generally point to the items that should be used to complete the puzzle, to the last, in which the solution is given. Hints in between these should provide pointers to help you solve the puzzle yourself. The hints can be found using the light bulb icon on each item\'s screen.'
}];
